import React from 'react';
import { UiMultiFileUploader } from '../ui-kit';

/* eslint-disable react/prop-types */
export function UiMultiFileUploaderAdapter({ input, ...rest }) {
  return <UiMultiFileUploader {...input} {...rest} />;
}
